export enum BatchReaderOption {
  EACH_ADJUDICATION = 'each_adjudication',
  EACH_LEVEL1 = 'each_level1'
}
